export default "__VITE_ASSET__OF9jEVT9__"